import { render, staticRenderFns } from "./ConstantsManagement.vue?vue&type=template&id=c84452ea&"
import script from "./ConstantsManagement.vue?vue&type=script&lang=js&"
export * from "./ConstantsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports